import styled from 'styled-components';
import { Box } from '@mui/material';
import { colors } from 'spw-theme';

export default styled(Box)`
  && {
    font-family: Roboto;
    font-style: normal;
    background: ${colors.white};
    border: 1px solid ${colors.veryLightGray};
    border-radius: 8px;
    padding: 16px;
  }
`;
